/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AuthIdentityOrgData } from './authIdentityOrgData';


export interface IrrConfigAuthIdentity { 
    supportOrg?: AuthIdentityOrgData;
    tenantOrg?: AuthIdentityOrgData;
}

